import { useMutation } from 'query';
import { getInvitationToken } from '../../services';

export const useGetInvitationTokenMutation = () =>
  useMutation<string, { communityId: string }>({
    async mutationFn({ communityId }) {
      const response = await getInvitationToken({ communityId });
      return response.data.token;
    },
  });
